import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaUc_1.mjs'
import FormChoose from './FormChooseUc_1.jsx'
import TableChoose from './TableChooseUc_1.jsx'
import api from './apiUc_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,

        async choose(map, node, modalProps) {
            const getQuery = query => {
                const {bizNodeType, taskNo} = map.root.data

                if ('DES' === bizNodeType) {
                    return {reqNo: taskNo, ...query}
                }
                else {
                    return query
                }
            }

            const items = await this._choose(
                map, node, {getQuery, ...modalProps}
            )

            return items.map(e => ({
                ...e,
                data: {...e.data, bizNodeType: 'UC'},
            }))
        },
    })
}
